
import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import Footer from "@/components/Footer";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Mail, Phone, MapPin, Clock } from "lucide-react";

const Contact = () => {
  const [contactInfo, setContactInfo] = useState<{ title: string; content: string } | null>(null);

  useEffect(() => {
    const fetchContactInfo = async () => {
      const { data, error } = await supabase
        .from('terms_policies')
        .select('title, content')
        .eq('category', 'contact')
        .single();

      if (error) {
        console.error('Error fetching contact info:', error);
        return;
      }

      if (data) {
        setContactInfo(data);
      }
    };

    fetchContactInfo();
  }, []);

  return (
    <div className="min-h-screen flex flex-col">
      <div className="container mx-auto px-4 py-8 flex-grow">
        <Card className="w-full max-w-4xl mx-auto">
          <CardHeader>
            <CardTitle className="text-2xl font-bold text-center">
              {contactInfo?.title || "Contact Us"}
            </CardTitle>
          </CardHeader>
          <CardContent>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div className="space-y-4">
                <div className="flex items-start space-x-3">
                  <Mail className="w-5 h-5 mt-1 text-primary" />
                  <div>
                    <h3 className="font-semibold">Email Support</h3>
                    <p className="text-sm text-muted-foreground">workprofession098@gmail.com</p>
                    <p className="text-sm text-muted-foreground">Response time: Within 24 hours</p>
                  </div>
                </div>
                <div className="flex items-start space-x-3">
                  <Phone className="w-5 h-5 mt-1 text-primary" />
                  <div>
                    <h3 className="font-semibold">Phone Support</h3>
                    <p className="text-sm text-muted-foreground">+91 9515011270</p>
                    <p className="text-sm text-muted-foreground">Available during business hours</p>
                  </div>
                </div>
                <div className="flex items-start space-x-3">
                  <MapPin className="w-5 h-5 mt-1 text-primary" />
                  <div>
                    <h3 className="font-semibold">Office Address</h3>
                    <p className="text-sm text-muted-foreground">
                      Bayzo<br />
                      Shamshabad Hyderabad
                    </p>
                  </div>
                </div>
                <div className="flex items-start space-x-3">
                  <Clock className="w-5 h-5 mt-1 text-primary" />
                  <div>
                    <h3 className="font-semibold">Business Hours</h3>
                    <p className="text-sm text-muted-foreground">
                      Monday - Sunday: 24 Hours
                    </p>
                  </div>
                </div>
              </div>
              <div className="prose prose-sm max-w-none">
                {contactInfo?.content ? (
                  <div dangerouslySetInnerHTML={{ __html: contactInfo.content.replace(/\n/g, '<br/>') }} />
                ) : (
                  <p className="text-center text-gray-500">Loading contact information...</p>
                )}
              </div>
            </div>
          </CardContent>
        </Card>
      </div>
      <Footer />
    </div>
  );
};

export default Contact;
